export const isYouTubeUrl = (url: string): boolean => {
  const regex = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/
  return !!url.match(regex)
}

export default isYouTubeUrl
